import React from 'react';
import { GraduationCap, Target } from 'lucide-react';

const WhatWeBuild = () => {
  const pillars = [
    {
      icon: GraduationCap,
      title: 'Training',
      modules: [
        'AI Training Wizard (custom training + videos)',
        'Content modernization',
        'Progress tracking and analytics'
      ],
      outcome: 'Faster ramp and consistent upskilling.',
      color: 'blue'
    },
    {
      icon: Target,
      title: 'Role Play',
      modules: [
        'Roleplay IQ (scenarios, coaching, scores)',
        'Gamification and leaderboards',
        'Performance improvement tracking'
      ],
      outcome: 'Practice-driven performance improvements.',
      color: 'indigo'
    }
  ];

  const colorClasses = {
    blue: 'from-blue-900/20 to-blue-800/20 border-blue-700',
    indigo: 'from-indigo-900/20 to-indigo-800/20 border-indigo-700'
  };

  return (
    <section className="py-20 px-6 bg-gray-950">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-white mb-4">
            What We Build With You
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            We tailor each pillar during onboarding to match your specific goals and workflows.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {pillars.map((pillar, index) => (
            <div
              key={index}
              className={`bg-gradient-to-br ${colorClasses[pillar.color]} rounded-2xl p-8 border hover:scale-105 transition-transform`}
            >
              <div className="w-16 h-16 bg-gray-900 border border-gray-700 rounded-2xl flex items-center justify-center mb-6 shadow-[0_0_20px_rgba(59,130,246,0.2)]">
                <pillar.icon className="w-8 h-8 text-blue-400" />
              </div>

              <h3 className="text-2xl font-bold text-white mb-4">{pillar.title}</h3>

              <ul className="space-y-3 mb-6">
                {pillar.modules.map((module, idx) => (
                  <li key={idx} className="flex items-start gap-2">
                    <div className="w-1.5 h-1.5 bg-blue-400 rounded-full mt-2 flex-shrink-0" />
                    <span className="text-gray-300 text-sm">{module}</span>
                  </li>
                ))}
              </ul>

              <div className="bg-gray-900/50 rounded-lg p-4 border border-gray-800">
                <p className="text-xs font-semibold text-blue-400 mb-1">Outcome:</p>
                <p className="text-sm text-gray-200 font-medium">{pillar.outcome}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhatWeBuild;
